import React from 'react';
import { Box, Container, Grid, Typography, IconButton, Divider, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { FooterContainer } from '../StyledComponents';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import {
  BUSINESS_ADDRESS,
  BUSINESS_EMAIL,
  BUSINESS_NAME,
  BUSINESS_PHONE,
  FACEBOOK_URL,
  GOOGLE_REVIEWS_URL,
  INSTAGRAM_URL,
} from '../../config/business';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { openConsentSettings } = useCookieConsent();

  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              {BUSINESS_NAME}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              Vakmanschap in stoffering sinds jaren. Uw specialist voor hoogwaardige 
              meubelstoffering, restauratie en maatwerk.
            </Typography>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              Contact
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
              <PhoneIcon sx={{ mr: 1, fontSize: '1.2rem' }} />
              <Typography variant="body2">{BUSINESS_PHONE}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
              <EmailIcon sx={{ mr: 1, fontSize: '1.2rem' }} />
              <Typography variant="body2">{BUSINESS_EMAIL}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
              <LocationOnIcon sx={{ mr: 1, fontSize: '1.2rem' }} />
              <Typography variant="body2">{BUSINESS_ADDRESS}</Typography>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              Volg Ons
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                href="https://wa.me/+31681677899"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
              <IconButton
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  },
                }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href={GOOGLE_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.2)',
                  },
                }}
              >
                <StarOutlineIcon />
              </IconButton>
            </Box>
            <Typography variant="body2" sx={{ mt: 2, opacity: 0.9 }}>
              <strong>Openingstijden:</strong><br />
              Ma-Vr: 8:00 - 17:00<br />
              Za: Op afspraak
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, backgroundColor: 'rgba(255,255,255,0.2)' }} />

        <Box sx={{ textAlign: 'center' }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 1.5 }}
          >
            <Button
              variant="text"
              component={RouterLink}
              to="/privacy"
              sx={{ color: 'rgba(255,255,255,0.88)' }}
            >
              Privacy en cookies
            </Button>
            <Button
              variant="text"
              onClick={openConsentSettings}
              sx={{ color: 'rgba(255,255,255,0.88)' }}
            >
              Cookie-instellingen
            </Button>
          </Stack>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {currentYear} Meester Stoffeerders. Alle rechten voorbehouden.
          </Typography>
        </Box>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
